
import "/var/www/tribe/shared/frontend_build/src/components/Layout/SmartLayout/index.less?modules";
export default {"menu": `menu-zzYzBeks`}
